// import { isProduction } from 'helpers'
import { hyphenate as hyphenateIS } from 'hyphen/is'
import { hyphenate as hyphenateEN } from 'hyphen/en-us'

const hyphenation = {
  el: {
    items: document.querySelectorAll<HTMLElement>('p, h1, h2, h3, h4, h5, h6, span, a, td'),
  },

  init() {
    // var options = {
    //   debug: !isProduction,
    //   minWordLength: 5
    // }

    this.el.items.forEach((element) => {
      element.childNodes.forEach((child) => {
        if (!child.hasChildNodes()) {
          if (child.nodeValue !== null && child.nodeValue.length !== 0) {
            if (document.documentElement.lang === 'is') {
              hyphenateIS(child.nodeValue).then((result) => {
                child.nodeValue = result
              })
            } else {
              hyphenateEN(child.nodeValue).then((result) => {
                child.nodeValue = result
              })
            }
          }
        }
      })
    })
  },
}

export default hyphenation
